import {Cohort} from 'common/widgets/cohorts-query-builder/models/cohort';
import {SerializedCohort} from 'common/widgets/cohorts-query-builder/models/types/serialized-cohort-types';

export enum CohortsModalError {
  NameRequired,
}

export enum CohortSaveAttempt {
  New = `new`,
  Edit = `edit`,
}

export interface CohortsModalState {
  name: string;
  showCreateEntityModal: boolean;
  loadingCohorts: boolean;
  loadingCohortCount: boolean;
  cohortCount: string;
  errors: Set<CohortsModalError>;
  cohort: Cohort;
  saveCohortAttempted: boolean;
  description: string;
  cohortSaveAttempt: CohortSaveAttempt;
}

export interface InlineCohortsModalAttrsJsxProps {
  attrs: {
    cohort: SerializedCohort;
    'project-id': number;
    'workspace-id': number;
    'data-group-id': string;
    'can-save'?: boolean;
    'can-edit'?: boolean;
    'can-apply-unsaved-cohort'?: boolean;
    'project-has-cohorts'?: boolean;
    'user-id'?: number;
    'show-cohort-count'?: boolean;
    'track-name'?: string;
    name?: string;
    open?: boolean;
    type?: string;
  };
  props?: EmptyObj;
}

export type InlineCohortsModalCommitEvent = CustomEvent<{
  id?: number;
  name: string;
  cohort: Cohort;
  savedAsNew: boolean;
}>;
